import React from 'react';
import { Helmet } from 'react-helmet-async';
import { BASE_URL } from '../components/SEO';

const Privacidade: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-3xl">
      <Helmet>
        <title>Política de Privacidade | eFortiPsi - Psicóloga Eliane Forti Fernandes</title>
        <meta name="description" content="Como o site eFortiPsi trata dados pessoais e cookies, conforme a LGPD e o Código de Ética Profissional do Psicólogo." />
        <link rel="canonical" href={`${BASE_URL}/privacidade`} />
      </Helmet>
      <div className="space-y-6">
        <h1 className="text-3xl font-bold text-[#2a3c5c] mb-6">
          Política de Privacidade – Eforti Psi
        </h1>

        <section>
          <h2 className="text-2xl font-semibold text-[#2a3c5c] mb-4">1. Introdução</h2>
          <p className="text-gray-700 mb-4">
            A Eforti Psi, representada por Eliane Forti Fernandes, compromete-se com a proteção e a privacidade dos dados pessoais de seus usuários. Esta Política de Privacidade tem como objetivo esclarecer como as informações são coletadas, utilizadas e protegidas, em conformidade com a Lei Geral de Proteção de Dados (LGPD) – Lei nº 13.709/2018 e demais normativas aplicáveis, incluindo o Código de Ética Profissional do Psicólogo, regulamentado pelo Conselho Regional de Psicologia de São Paulo (CRP-SP).
          </p>
          <p className="text-gray-700 mb-4">
            Ao utilizar os serviços oferecidos pelo site www.efortipsi.com.br, o usuário declara estar ciente e de acordo com os termos descritos nesta política.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-[#2a3c5c] mb-4">2. Coleta de Dados Pessoais</h2>
          <p className="text-gray-700 mb-4">
            A Eforti Psi pode coletar dados pessoais dos usuários nas seguintes situações:
          </p>
          <ul className="list-disc pl-6 mb-4 text-gray-700">
            <li>Agendamento de consultas (via e-mail ou WhatsApp)</li>
            <li>Envio de mensagens pelo formulário de contato</li>
            <li>Navegação no site e interação com conteúdos</li>
          </ul>
          <p className="text-gray-700 mb-4">
            Os dados coletados podem incluir, mas não se limitam a:
          </p>
          <ul className="list-disc pl-6 mb-4 text-gray-700">
            <li>Nome completo</li>
            <li>Endereço de e-mail</li>
            <li>Número de telefone</li>
            <li>Informações inseridas pelo usuário nos campos de contato</li>
          </ul>
          <p className="text-gray-700 mb-4">
            Este site não coleta informações sensíveis, como dados de saúde ou prontuários psicológicos, respeitando o sigilo profissional conforme o Código de Ética Profissional do Psicólogo.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-[#2a3c5c] mb-4">3. Finalidade do Tratamento dos Dados</h2>
          <p className="text-gray-700 mb-4">
            Os dados coletados são utilizados exclusivamente para:
          </p>
          <ul className="list-disc pl-6 mb-4 text-gray-700">
            <li>Gerenciamento de agendamentos de consultas psicológicas</li>
            <li>Respostas a dúvidas e solicitações do usuário</li>
            <li>Comunicação sobre serviços e suporte técnico</li>
            <li>Melhorias na experiência de navegação do usuário</li>
          </ul>
          <p className="text-gray-700 mb-4">
            Nenhuma informação coletada será utilizada para fins comerciais ou publicitários sem consentimento prévio.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-[#2a3c5c] mb-4">4. Compartilhamento de Informações</h2>
          <p className="text-gray-700 mb-4">
            Os dados pessoais não serão compartilhados com terceiros, salvo nas seguintes hipóteses:
          </p>
          <ul className="list-disc pl-6 mb-4 text-gray-700">
            <li>Para cumprimento de exigências legais ou ordens judiciais</li>
            <li>Para resguardar direitos da Eforti Psi em eventuais demandas legais</li>
            <li>Quando houver consentimento expresso do usuário</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-[#2a3c5c] mb-4">5. Segurança e Armazenamento dos Dados</h2>
          <p className="text-gray-700 mb-4">
            A Eforti Psi adota medidas técnicas e organizacionais para garantir a segurança dos dados, protegendo-os contra acessos não autorizados, alterações, divulgações ou destruições indevidas.
          </p>
          <p className="text-gray-700 mb-4">
            As informações coletadas são armazenadas de forma segura e mantidas pelo tempo necessário para cumprimento das finalidades descritas nesta política.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-[#2a3c5c] mb-4">6. Direitos do Usuário</h2>
          <p className="text-gray-700 mb-4">
            Conforme a LGPD, o usuário pode exercer os seguintes direitos em relação aos seus dados:
          </p>
          <ul className="list-disc pl-6 mb-4 text-gray-700">
            <li>Solicitar acesso às informações pessoais armazenadas</li>
            <li>Retificar dados incorretos ou desatualizados</li>
            <li>Solicitar a exclusão dos dados pessoais, respeitando obrigações legais</li>
            <li>Revogar o consentimento para o tratamento de dados</li>
          </ul>
          <p className="text-gray-700 mb-4">
            Para exercer esses direitos, o usuário pode entrar em contato pelo e-mail contato@efortipsi.com.br.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-[#2a3c5c] mb-4">7. Alterações na Política de Privacidade</h2>
          <p className="text-gray-700 mb-4">
            A Eforti Psi pode atualizar esta Política de Privacidade periodicamente. O usuário será informado sobre mudanças relevantes por meio deste site.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-[#2a3c5c] mb-4">8. Contato</h2>
          <p className="text-gray-700 mb-4">
            Dúvidas ou solicitações sobre esta Política de Privacidade devem ser encaminhadas para:<br />
            📩 E-mail: contato@efortipsi.com.br<br />
            📲 Agendamentos: contato@efortipsi.com.br ou WhatsApp
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-[#2a3c5c] mb-4">9. Política de Cookies</h2>
          <p className="text-gray-700 mb-4">
            Este site utiliza cookies para melhorar a experiência do usuário e otimizar a navegação. Cookies são pequenos arquivos de texto armazenados no dispositivo do usuário quando ele acessa o site.
          </p>

          <h3 className="text-xl font-semibold text-[#2a3c5c] mb-3">9.1. Tipos de Cookies Utilizados</h3>
          <p className="text-gray-700 mb-4">
            A Eforti Psi pode utilizar os seguintes tipos de cookies:
          </p>
          <ul className="list-disc pl-6 mb-4 text-gray-700">
            <li>Cookies Essenciais: Necessários para o funcionamento do site e não podem ser desativados</li>
            <li>Cookies de Desempenho: Coletam informações sobre como os usuários utilizam o site, ajudando a melhorar seu funcionamento</li>
            <li>Cookies Funcionais: Permitem que o site lembre suas preferências (como idioma e localização)</li>
            <li>Cookies de Terceiros: Algumas funcionalidades podem utilizar cookies de terceiros, como ferramentas de análise (exemplo: Google Analytics)</li>
          </ul>

          <h3 className="text-xl font-semibold text-[#2a3c5c] mb-3">9.2. Ferramentas de Medição</h3>
          <p className="text-gray-700 mb-4">
            Para saber quantas pessoas visitam o site e por qual canal chegaram, usamos:
          </p>
          <ul className="list-disc pl-6 mb-4 text-gray-700">
            <li>Vercel Web Analytics: conta visitas de forma agregada e anônima, sem cookies e sem identificar o visitante</li>
            <li>Google Analytics 4 (via Google Tag Manager): só é ativado se o usuário aceitar os cookies no aviso do site; registra páginas vistas e cliques no botão do WhatsApp, sem o conteúdo das mensagens</li>
            <li>Origem da visita: quando o usuário chega por um link do YouTube, Instagram ou TikTok, o site guarda essa origem apenas no próprio navegador, durante a sessão, para incluí-la no texto inicial da mensagem do WhatsApp. O usuário pode apagar ou editar esse texto antes de enviar.</li>
          </ul>
          <p className="text-gray-700 mb-4">
            Não utilizamos pixels de redes sociais, remarketing ou publicidade direcionada.
          </p>

          <h3 className="text-xl font-semibold text-[#2a3c5c] mb-3">9.3. Gerenciamento de Cookies</h3>
          <p className="text-gray-700 mb-4">
            O usuário pode configurar seu navegador para bloquear ou excluir cookies a qualquer momento. No entanto, isso pode afetar a experiência de navegação e impedir o funcionamento de algumas funcionalidades do site.
          </p>
          <p className="text-gray-700">
            Para mais informações sobre o uso de cookies, entre em contato pelo e-mail contato@efortipsi.com.br.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Privacidade;
